import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import PropTypes from 'prop-types';

import { COLORS } from '../../../Constant/COLORS';

const ImageCard = ({ title, desc, src }) => {
  return (
    <Stack gap={3}>
      <Box>
        <img src={src} alt='' />
      </Box>
      <Typography variant='h6' color={COLORS.blue} fontWeight={600}>
        {title}
      </Typography>
      <Typography color={COLORS.blue}>{desc}</Typography>
    </Stack>
  );
};

ImageCard.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  src: PropTypes.string,
};

export default ImageCard;
